module.exports = __webpack_public_path__ + "static/media/ils_login.f51016fc.svg";